import { i as l } from "./index761.mjs";
var e = l, o = function(a) {
  return typeof a == "object" ? a !== null : e(a);
};
export {
  o as i
};
